module.exports = __webpack_public_path__ + "img/header-engagementRingsGold@2x.8432325.jpg";